module.exports = __webpack_public_path__ + "img/aygaz-conversion-club-infographic-02.16a69e85.jpg";